import { apiGet } from './apiConfig';

/** One aggregated bucket from GET `/coverage/unit_locations/`. */
export interface UnitLocationRow {
  city: string | null;
  country: string;
  units_count: number;
  latitude: number;
  longitude: number;
}

/**
 * Unit locations for the coverage map (JWT required).
 * - **Admin:** omit params for all units; or `{ user_id_no }` to scope to that client.
 * - **Client:** omit params for “my units” only; `{ filter_by_units: false }` for global aggregate (matches “All” toggle).
 */
export function fetchUnitLocations(params?: {
  user_id_no?: number;
  filter_by_units?: boolean;
}): Promise<UnitLocationRow[]> {
  const query: Record<string, string | number | boolean> = {};
  if (params?.user_id_no != null && Number.isFinite(params.user_id_no)) {
    query.user_id_no = params.user_id_no;
  }
  if (params?.filter_by_units === false) {
    query.filter_by_units = false;
  }
  const keys = Object.keys(query);
  return apiGet(
    '/coverage/unit_locations/',
    keys.length ? query : undefined
  ) as Promise<UnitLocationRow[]>;
}
